<div class="settings">
    <div class="settings-header">
        @if (showConsent) {
            <a class="settings-header-back back-button" (click)="showConsent = false">
                <i class="fa-solid fa-chevron-left"></i>
                <div class="back text">{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}</div>
            </a>
        }

        <div class="settings-header-logo">
            <img
                [src]="companyLogo()"
                (error)="getHowdyLogo()"
                [class.not-howdy]="!isHowdyLogo"
                class="logo"
                alt="logo"
            >
            <p class="text">{{ 'WebApp.v1.Shared.AwarenessByHowdy' | translate }}</p>
        </div>
    </div>

    <div class="settings-content">
        <div class="settings-content-header">
            @if (isManagerUnsubscribe) {
              <div class="settings-content-header-title">{{ 'App.v2.Views.Settings.Notifications' | translate }}</div>
            } @else {
                @if (showConsent) {
                    <div class="settings-content-header-title">{{ 'App.v2.Views.Consent.Title' | translate }}</div>
                } @else {
                    <div class="settings-content-header-title">{{ 'App.v2.Views.Unsubscribe.Title' | translate }}</div>
                }
            }

            @if (isManagerUnsubscribe) {
                <div class="settings-content-header-name margin">{{ 'App.v2.Views.Unsubscribe.MonthlyReport.Footer' | translate }}</div>
            } @else {
                @if (!showConsent && !unsubscribeResult) {
                    <div class="settings-content-header-name">{{ 'App.v2.Views.Unsubscribe.Subtitle.Active' | translate: { firstname: firstname, lastname: lastname } }}</div>
                    <div class="settings-content-header-name margin" [innerHTML]="'App.v2.Views.Unsubscribe.Explainer' | translate : { company: unsubscribe?.companyName, contactPerson: unsubscribe?.contactPerson }"></div>
                }
            }
        </div>

        <div class="settings-content-container">
          @if (isManagerUnsubscribe) {
            <form [formGroup]="form" class="settings-content-container-form">
              <div class="settings-content-container-form-row">
                  <app-checkbox formControlName="notifyByEmail">
                      <div class="settings-content-container-form-row-checkbox">{{ 'WebApp.v1.Settings.EmailNotification' | translate }}</div>
                  </app-checkbox>
              </div>
            </form>
          } @else {
            @if (showConsent) {
                <div class="markdown-content" [innerHTML]="unsubscribe?.tosContentMarkdown | markdown"></div>
                <div class="markdown-content-buttons">
                    <app-button
                        class="button"
                        [fontSize]="12"
                        [label]="'App.v2.Views.Settings.ToS.Resend.Button' | translate"
                        backgroundColor="transparent"
                        [border]="'1px solid #2DADC8'"
                        textColor="#000"
                        (click)="resendTermsOfService()"
                    ></app-button>

                    <app-button
                        class="button"
                        [fontSize]="12"
                        [label]="'App.v2.Views.Consent.Button.Recall' | translate"
                        backgroundColor="transparent"
                        [border]="'1px solid #C53333'"
                        textColor="#000"
                        (click)="recallTermsOfService()"
                    ></app-button>
                </div>
            } @else if (unsubscribeResult) {
                <div
                    class="settings-content-container-result"
                    [class.success]="unsubscribeResult === UnsubscribeResult.Success"
                    [class.error]="unsubscribeResult === UnsubscribeResult.Error"
                >
                    <div class="settings-content-container-result-icon">
                        @if (unsubscribeResult === UnsubscribeResult.Success) {
                            <i class="fa-solid fa-check"></i>
                        } @else {
                            <i class="fa-solid fa-xmark"></i>
                        }
                    </div>

                    @if (unsubscribeResult === UnsubscribeResult.Success) {
                        <div class="settings-content-container-result-title">{{ 'App.v2.Views.Unsubscribe.Result.Success.Title' | translate }}</div>
                        <div class="settings-content-container-result-text">
                            {{ 'App.v2.Views.Unsubscribe.Result.Success.Text' | translate }}
                        </div>
                    } @else {
                        <div class="settings-content-container-result-title">{{ 'App.v2.Views.Unsubscribe.Result.Error.Title' | translate }}</div>
                        <div class="settings-content-container-result-text">
                            {{ 'App.v2.Views.Unsubscribe.Result.Error.Text' | translate }}
                        </div>
                    }
                </div>

                @if (unsubscribeResult === UnsubscribeResult.Error) {
                    <app-button
                        class="button reset"
                        [fontSize]="12"
                        [label]="'App.v2.Views.Unsubscribe.Result.Error.Button' | translate"
                        backgroundColor="transparent"
                        [border]="'1px solid #C53333'"
                        textColor="#000"
                        (click)="resetUnsubscribeFlow()"
                    ></app-button>
                }
            } @else {
                <form [formGroup]="form" class="settings-content-container-form">
                    <div class="box" [class.hidden]="!showForm">
                        <div class="settings-content-container-form-row"> 
                            <app-checkbox formControlName="notifyBySMS">
                                <div class="settings-content-container-form-row-checkbox">{{ 'WebApp.v1.Settings.SmsNotification' | translate }}
                                    @if (nextSMSNotificationDate) {
                                        <span>{{ 'WebApp.v1.Shared.Buttons.Next' | translate }} {{ nextSMSNotificationDate | date:'dd/MM/YYYY' }}</span>
                                    }
                                </div>
                            </app-checkbox>
                        </div>

                        <div class="settings-content-container-form-row">
                            <app-checkbox formControlName="notifyByEmail">
                                <div class="settings-content-container-form-row-checkbox">{{ 'WebApp.v1.Settings.EmailNotification' | translate }}
                                    @if (nextEmailNotificationDate) {
                                        <span>{{ 'WebApp.v1.Shared.Buttons.Next' | translate }} {{ nextEmailNotificationDate | date:'dd/MM/YYYY' }}</span>
                                    }
                                </div>
                            </app-checkbox>
                        </div>

                        <div class="settings-content-container-form-row">
                            <app-checkbox formControlName="notifyByPush">
                                <div class="settings-content-container-form-row-checkbox">{{ 'WebApp.v1.Settings.PushNotification' | translate }}
                                    @if (nextPushNotificationDate) {
                                        <span>{{ 'WebApp.v1.Shared.Buttons.Next' | translate }} {{ nextPushNotificationDate | date:'dd/MM/YYYY' }}</span>
                                    }
                                </div>
                            </app-checkbox>
                        </div>

                        <div class="settings-content-container-form-row consent" (click)="showConsent = true">
                            <div class="settings-content-container-form-row-checkbox">{{ 'App.v2.Views.Consent.Title' | translate }}</div>
                            <i class="fa-regular fa-file-lines"></i>
                        </div>
                    </div>

                    <div class="settings-content-container-select" [class.visible]="!showForm">
                        <app-select
                            formControlName="reason"
                            class="select-container"
                            [options]="selectOptions"
                            [title]="'WebApp.v1.Survey.Description.ClickOption' | translate"
                        ></app-select>
                    </div>
                </form>

                <app-button
                    class="button reset"
                    [fontSize]="12"
                    [label]="'WebApp.v1.Shared.Buttons.Unsubscribe' | translate"
                    backgroundColor="transparent"
                    [border]="'1px solid #C53333'"
                    textColor="#000"
                    [disabled]="isDisabled"
                    [waitCursor]="isSubmitting"
                    (click)="onUnsubscribeClick()"
                ></app-button>
            }
          }
        </div>
    </div>
</div>
